import { adLogger } from '../../eventLogger/adLogger/adLogger.web';
import type { LogAdEventParams } from './types';

export const logAdEvent = ({ action, ad }: LogAdEventParams) => {
  if (ad == null) {
    return;
  }

  adLogger.log({
    analytics: {
      action,
      ...ad,
    },
  });
};
